import Vue from 'vue'
import store from '@/store'
import { mapGetters } from 'vuex'

// @ToDo: Супер мега костыли, компонент рендерится с этим миксином, до блядь, нахуй, загрузки, прав блядь.
export default {
  data() {
    return {
      PERMISSIONS_CONSTANTS: Vue.config.permissions.PERMISSIONS_CONSTANTS,
      DENIED_CONSTANTS: Vue.config.permissions.DENIED_CONSTANTS,
      userPermission: store.getters.userSelfPermissions,
    }
  },
  computed: {
    ...mapGetters(['userSelfPermissions']),
    userData() {
      return store.getters.user
    },
  },
  watch: {
    userSelfPermissions(val) {
      this.userPermission = val
    },
  },
  methods: {
    checkPermission(permissionName) {
      return (this.userData && this.userData.is_superuser) || _.includes(this.userPermission, permissionName)
    },
    checkDenied(deniedName) {
      return !((this.userData && this.userData.is_superuser) || _.includes(this.userPermission, deniedName))
    },
  },
}
